import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { BaseFormPageComponent } from '../../../../../shared/base/components/base-form-page.component';
import { TextParserIfConditionType } from './../../../../../../core/api/models/text-parser-if-condition-type';

@Component({
  selector: 'app-text-parser-if-condition',
  templateUrl: './text-parser-if-condition.component.html',
  styleUrls: ['./text-parser-if-condition.component.scss'],
  imports: [BaseFormModule],
})

export class TextParserIfConditionComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  formId: string = 'textParserIfConditionForm';

  model: ifConditionValueDto = {};

  @Input() ifConditionType?: TextParserIfConditionType;
  @Input() ifConditionValue?: string;

  get TextParserIfConditionType() {
    return this.TextParserIfConditionType;
  }
  isShowIfConditionValue: boolean = false;

  @Output('ifConditionType') output_ifConditionType =
    new EventEmitter<TextParserIfConditionType>();
  @Output('ifConditionValue') output_ifConditionValue =
    new EventEmitter<string>();

  //isShow
  isShowUsePhonebook: boolean = false;
  isShowUseDataBaseTable: boolean = false;
  isShowUseTokenService: boolean = false;
  isOnlyNumber: boolean = false;

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.account);
    }
  }

  initModel() {}

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['ifConditionValue'] && this.ifConditionValue) {
        this.convertJsonToObject();
        this.onChangeIfConditionType(this.ifConditionType, true);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  initForm() {
    this.form = new FormGroup({
      ifConditionType: new FormControl(),
      ifConditionValue: new FormControl(),

      phonebookId: new FormControl(),
      contactFieldName: new FormControl(),

      ipAndPort: new FormControl(),
      userName: new FormControl(),
      password: new FormControl(),
      database: new FormControl(),
      table: new FormControl(),
      field: new FormControl(),

      apiAddress: new FormControl(),
      token: new FormControl(),
      authorizationScheme: new FormControl(),
    });
  }

  //#region ifCondition

  onChangeIfConditionType(
    type: TextParserIfConditionType,
    noDeletePreviousValues?: boolean
  ) {
    try {
      if (!noDeletePreviousValues) {
        this.hideAllDynamicFormulaInput();
        this.ifConditionValue = '';
        this.emitIfConditionValue();
      }

      this.isShowIfConditionValue = true;
      this.ifConditionType = type;
      this.emitIfConditionType();

      switch (type) {
        case TextParserIfConditionType.All:
          this.isShowIfConditionValue = false;
          break;
        case TextParserIfConditionType.NationalCode:
          this.isShowIfConditionValue = false;
          break;
        case TextParserIfConditionType.EqualToPhonebookField:
          this.isShowUsePhonebook = true;
          this.isShowIfConditionValue = false;
          break;
        // case TextParserIfConditionType.UseDataBaseTable:
        //   this.isShowUseDataBaseTable = true;
        //   this.isShowIfConditionValue = false;
        //   break;
        case TextParserIfConditionType.TokenService:
          this.isShowUseTokenService = true;
          this.isShowIfConditionValue = false;
          break;
        case TextParserIfConditionType.ValueLessThan:
          this.isOnlyNumber = true;
          break;
        case TextParserIfConditionType.ValueGreaterThan:
          this.isOnlyNumber = true;
          break;
        case TextParserIfConditionType.ValueContain:
        case TextParserIfConditionType.ValueEndWith:
        case TextParserIfConditionType.ValueEqualTo:
        case TextParserIfConditionType.ValueStartWith:
          this.isOnlyNumber = false;
          break;
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  hideAllDynamicFormulaInput() {
    this.model = {};
    this.isShowUsePhonebook = false;
    this.isShowUseDataBaseTable = false;
    this.isShowUseTokenService = false;
    this.isOnlyNumber = false;
  }

  onChangeIfConditionValue(value: string) {
    this.ifConditionValue = value;
    this.emitIfConditionValue();
  }

  //#endregion

  //#region Json

  onCreateJson(): void {
    this.convertObjectToJson();
  }

  convertObjectToJson() {
    try {
      this.ifConditionValue = JSON.stringify(this.model);
      this.emitIfConditionValue();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  convertJsonToObject() {
    try {
      if (
        this.ifConditionType ==
          TextParserIfConditionType.EqualToPhonebookField ||
        // this.ifConditionType == TextParserIfConditionType.UseDataBaseTable ||
        this.ifConditionType == TextParserIfConditionType.TokenService
        // this.ifConditionType == TextParserIfConditionType.ApiParams
      )
        this.model = JSON.parse(this.ifConditionValue);
      else return;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#endregion

  //#region emit

  emitIfConditionType() {
    this.output_ifConditionType.emit(this.ifConditionType);
  }

  emitIfConditionValue() {
    this.output_ifConditionValue.emit(this.ifConditionValue);
  }

  //#endregion
}

export class ifConditionValueDto {
  phonebookId?: number;
  contactFieldName?: string;

  ipAndPort?: string;
  userName?: string;
  password?: string;
  database?: string;
  table?: string;
  field?: string;

  apiAddress?: string;
  token?: string;
  authorizationScheme?: number;
}
